import { render, staticRenderFns } from "./expandCollapse.vue?vue&type=template&id=ceb253e2&scoped=true"
import script from "./expandCollapse.vue?vue&type=script&lang=js"
export * from "./expandCollapse.vue?vue&type=script&lang=js"
import style0 from "./expandCollapse.vue?vue&type=style&index=0&id=ceb253e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb253e2",
  null
  
)

export default component.exports